module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/sns_2-04291ee92808dc7a319f68faa22eec39.png";